/**
 * @ignore
 * Created by daletan on 6/17/16.
 */

'use strict';

const React = require('react');

const PropTypes = require('prop-types');

// Stores
const UserStore = require('../../global/stores/UserStore.es');
const PriceStore = require('../../global/stores/PriceStore.es.js');
const ItemStore = require('../../newPdp/stores/ItemStore.es');

// Components
const FormattedPrice = require('../Price/FormattedPrice');

// Helpers
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const {pageTypes} = require('dibs-buyer-layout/src/entries/index');
const classnames = require('classnames');

// Styles
const styles = require('./styles.scss');

const classesMap = {
    net: `price-net ${styles.net}`,
    retail: `price-retail ${styles.retail}`,
    sale: styles.salePrice,
};

// don't conflate this with classes
// since classes can be more fluid
const dataTnNames = {
    net: 'net-price',
    retail: 'retail-price',
};

function getTestName(pageType, type) {
    const tn = dataTnNames[type] || '';
    if (tn) {
        return `${pageType}-${tn}`;
    } else if (pageType && type) {
        return `${pageType}-${type}`;
    }
    return type;
}

const PriceComponent = props => {
    const {
        currency,
        retailPrice,
        netPrice,
        originalPrice,
        salePrice,
        copy = {},
        isSoldIndividually,
        type,
        priceDisplays,
        pageType = 'pdp',
    } = props;
    const testName = getTestName(pageType, type);
    const wrappingClass = classesMap[type];
    const classes = classnames(wrappingClass, 'notranslate', {
        [styles.hasNetPrice]: priceDisplays.showNetPrice,
    });

    let price = netPrice;
    if (type === 'retail') {
        // Original retail price from price locks is used to calculate % off for sale, display original retail for sale
        price = priceDisplays.showSalePrice ? originalPrice : retailPrice;
    } else if (type === 'sale') {
        price = salePrice;
    }

    return (
        <div className={classes} data-tn={testName}>
            <FormattedPrice
                copy={copy}
                priceDisplays={priceDisplays}
                isSoldIndividually={isSoldIndividually}
                price={price}
                currency={currency}
                type={type}
            />
        </div>
    );
};

PriceComponent.defaultProps = {
    type: 'net',
};

PriceComponent.propTypes = {
    type: PropTypes.string,
    isSoldIndividually: PropTypes.bool,
    currency: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    retailPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    netPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    originalPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    salePrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    copy: PropTypes.object,
    pageType: PropTypes.string,
    priceDisplays: PropTypes.object.isRequired,
};

const PriceComponentConnected = provideContext(
    connectToStores(PriceComponent, [ItemStore, PriceStore, UserStore], context => {
        const userStore = context.getStore(UserStore);
        const itemStore = context.getStore(ItemStore);
        const item = itemStore.getItem();
        const priceStore = context.getStore(PriceStore);
        const processedPriceData = priceStore.processPrice(item);
        const {
            netPriceData = {},
            originalPriceData = {},
            retailPriceData = {},
            salePriceData = {},
        } = processedPriceData;
        return {
            copy: itemStore.getCopy(),
            currency: userStore.getCurrency(),
            isSoldIndividually: itemStore.getSoldIndividually(
                netPriceData.model || retailPriceData.model
            ),
            netPrice: netPriceData.price,
            originalPrice: originalPriceData.price,
            priceDisplays: processedPriceData.priceDisplays,
            retailPrice: retailPriceData.price,
            salePrice: salePriceData.price,
        };
    })
);

const PercentageOffComponent = props => {
    const { copy = {}, pageType = 'pdp', percentageOff } = props;
    const { priceStates } = copy || {};
    const classes = classnames('price-percent-off', 'notranslate', styles.percentOff);

    return (
        <span className={classes} data-tn={`${pageType}-percentage-diff`}>
            {`${percentageOff} ${priceStates.off}`}
        </span>
    );
};

PercentageOffComponent.defaultProps = {
    type: 'net',
};

PercentageOffComponent.propTypes = {
    retailPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    netPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    originalPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    salePrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    percentageOff: PropTypes.string,
    copy: PropTypes.object,
    pageType: PropTypes.string,
    type: PropTypes.string,
};

const PercentageOffComponentConnected = provideContext(
    connectToStores(PercentageOffComponent, [ItemStore, PriceStore, UserStore], context => {
        const itemStore = context.getStore(ItemStore);
        const item = itemStore.getItem();
        const priceStore = context.getStore(PriceStore);
        const processedPriceData = priceStore.processPrice(item);
        const {
            netPriceData = {},
            originalPriceData = {},
            retailPriceData = {},
            salePriceData = {},
            percentageOff = '',
        } = processedPriceData;

        return {
            copy: itemStore.getCopy(),
            netPrice: netPriceData.price,
            pageType: pageTypes.PAGE_TYPE.PDP,
            originalPrice: originalPriceData.price,
            percentageOff,
            retailPrice: retailPriceData.price,
            salePrice: salePriceData.price,
        };
    })
);

module.exports = {
    PriceComponent: PriceComponentConnected,
    PercentageOffComponent: PercentageOffComponentConnected,
    RawPriceComponent: PriceComponent,
    RawPercentageOffComponent: PercentageOffComponent,
};



// WEBPACK FOOTER //
// ./assets/js/components/ReducedPrice/ReducedPriceComponents.jsx